import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

import { computed } from 'vue'

// Source: epic-spinners library,
// https://github.com/epicmaxco/epic-spinners/blob/master/src/components/lib/HollowDotsSpinner.vue


export default /*#__PURE__*/_defineComponent({
  __name: 'HollowDotsSpinner',
  props: {
    animationDuration: { default: 1000 },
    dotSize: { default: 15 },
    dotsNum: { default: 3 },
    color: { default: '#fff' }
  },
  setup(__props: any) {

const props = __props as { animationDuration: number, dotSize: number, dotsNum: number, color: string };



const horizontalMargin = computed(() => {
  return props.dotSize / 2
})

const spinnerStyle = computed(() => {
  return {
    height: `${props.dotSize}px`,
    width: `${(props.dotSize + horizontalMargin.value * 2) * props.dotsNum}px`,
  }
})

const dotStyle = computed(() => {
  return {
    animationDuration: `${props.animationDuration}ms`,
    width: `${props.dotSize}px`,
    height: `${props.dotSize}px`,
    margin: `0 ${horizontalMargin.value}px`,
    borderWidth: `${props.dotSize / 5}px`,
    borderColor: props.color,
  }
})

const dotsStyles = computed(() => {
  const dotsStyles = []
  const delayModifier = 0.3
  const basicDelay = 1000
  for (let i = 1; i <= props.dotsNum; i++) {
    const style = Object.assign(
      {
        animationDelay: `${basicDelay * i * delayModifier}ms`,
      },
      dotStyle.value,
    )
    dotsStyles.push(style)
  }
  return dotsStyles
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "hollow-dots-spinner",
    style: _normalizeStyle(_unref(spinnerStyle))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dotsStyles), (ds, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "dot",
        style: _normalizeStyle(ds)
      }, null, 4))
    }), 128))
  ], 4))
}
}

})